import React from 'react';
import '../../styles/pages/characters.scss'
import ReactPlayer from 'react-player';

const CharacterModal = ({modal, setModal, url, characters}) => (
  <picture className={`${modal["visible"] ? "character-modal modal " : "character-modal modal modal-hidden "}`}>
    <button className="modal-close"
      onClick={()=>{
        setModal({...modal, "visible": false})
      }}
    >
      <img src={`${process.env.PUBLIC_URL}/img/ui/btn_popup_close.png`} alt="" />
    </button>
    <button className={`left-arrow ${modal['current']===0 && "disabled"}`}
          onClick={()=>{
            setModal({...modal, 'current': modal["current"]-1})
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/img/ui/btn_popup_prev.png`} alt="" />
        </button>
    <div className="modal-contents">
      <div key={modal.current} className={characters[modal.current].catch ? "fade-in main-character-card" : "fade-in character-card"}>
        <div className={`left ${url.indexOf("sub") !== -1 ? 'sub-left' : ''}`}>
          <div className="character-names">
          <div className="grid-overlap">
            <h2 className={`character-desc ${characters[modal.current].name==="Higan Zesshosai" ? "higan" : characters[modal.current].name.toLowerCase()}-text`}>
              {characters[modal.current].desc}
            </h2>
            <h2 className={`character-desc-outline ${characters[modal.current].name==="Higan Zesshosai" ? "higan" : characters[modal.current].name.toLowerCase()}-color`}>
              {characters[modal.current].desc}
            </h2>
          </div>
          <div className="grid-overlap">
          <h1 className={`character-name ${characters[modal.current].name==="Higan Zesshosai" ? "higan" : characters[modal.current].name.toLowerCase()}-text`}>
            {characters[modal.current].name}
          </h1>          
          <h1 className={`character-name-outline ${characters[modal.current].name==="Higan Zesshosai" ? "higan" : characters[modal.current].name.toLowerCase()}-color`}>
            {characters[modal.current].name}
          </h1>
          </div>
          </div>
            <p className="character-para black-text">
              {characters[modal.current].para}
            </p>
            {
              url.indexOf("sub") !== -1 ? <></> :
              <div className="character-info-wrapper">
                <div className="video-container">
                  <div className="video-wrapper">
                    <ReactPlayer
                      url={
                        url.indexOf("sub") !== -1 ? <></> :
                        url.indexOf('generic') !== -1 ?
                      `${process.env.PUBLIC_URL}/img/video/generic_${modal["current"]+1 > 9 ? modal["current"]+1 : "0"+(modal["current"]+1)}.mp4` : 
                      `${process.env.PUBLIC_URL}/img/video/main_${modal["current"]+1 > 9 ? modal["current"]+1 : "0"+(modal["current"]+1)}.mp4`
                      }
                      autoplay playing loop controls={false} muted={true} />
                  </div>
                </div>
              </div>
            }
        </div>
        <div className="right">
          {
            characters[modal.current].catch && <h3 className={`character-catch ${characters[modal.current].name==="Higan Zesshosai" ? "higan" : characters[modal.current].name.toLowerCase()}-text`}>
              {characters[modal.current].catch}
            </h3>
          }
          {
            characters[modal.current].catch && <h3 className={`character-outline ${characters[modal.current].name==="Higan Zesshosai" ? "higan" : characters[modal.current].name.toLowerCase()}-color`}>
              {characters[modal.current].catch}
            </h3>
          }
          <div className={`art-wrapper ${url.indexOf('generic') !== -1 && 'generic-character_art'}`}>
            <img src={ `${process.env.PUBLIC_URL}/img/characters/${url.substring(0, url.indexOf('.'))}${modal["current"]+1 > 9 ? modal["current"]+1 : "0"+(modal["current"]+1)}${url.substring(url.indexOf('.'), url.length)}`
              }  alt="" />
          </div>
          {
            url.indexOf('sub') !== -1 ? <></> :
            characters[modal.current].catch ?
            <img src={`${process.env.PUBLIC_URL}/img/characters/popup_bg_main_${modal["current"]+1 > 9 ? modal["current"]+1 : "0"+(modal["current"]+1)}_sp${url.substring(url.indexOf('.'), url.length)}`} alt={characters[modal.current].name} className="character-bg"/> :
            <img src={`${process.env.PUBLIC_URL}/img/characters/popup_bg_generic_${modal["current"]+1 > 9 ? modal["current"]+1 : "0"+(modal["current"]+1)}_sp${url.substring(url.indexOf('.'), url.length)}`} alt={characters[modal.current].name} className="character-bg"/>
          }
          {
            characters[modal.current].catch && <img src={`${process.env.PUBLIC_URL}/img/characters/popup_bg_paint_main_${modal["current"]+1 > 9 ? modal["current"]+1 : "0"+(modal["current"]+1)}${url.substring(url.indexOf('.'), url.length)}`} alt={characters[modal.current].name} className="character-splatter"/>
          }
        </div>
      </div>
    </div>
          <img className='esrb mx-auto' src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`} alt='esrb rp-e10' 
              style={{
              position: 'absolute',
              maxWidth: '200px',
              bottom: 0,
              right: 0,
              margin: 5,
              zIndex: 2
            }}
          />
    <button className={`right-arrow ${modal['current']===modal.size && "disabled"}`}
      onClick={()=>{
        setModal({...modal, 'current': modal["current"]+1, url: `${url.substring(0, url.indexOf('.'))}${modal["current"]+1}${url.substring(url.indexOf('.'), url.length)}`})
      }}
    >
      <img src={`${process.env.PUBLIC_URL}/img/ui/btn_popup_next.png`} alt="" />
    </button>
  </picture>
)

export default CharacterModal;